import { Controller } from "@hotwired/stimulus";
import { updateTooltipTitle } from "../../utils/misc";
import { numberToCurrency } from "../../utils/number_utils";

export default class extends Controller {
  connect() {
    App.cable.subscriptions.create(
      { channel: "PurchaseInvoiceChannel", stream_name: "currency_conversion" },
      {
        received: (data) => {
          const purchaseRow = this._purchaseRow(data.purchase_invoice_id);
          if (!purchaseRow) {
            return;
          }

          if (data.currency_conversion_done) {
            this._displayEuroAmount(purchaseRow, data);
          } else {
            this._displayOngoingExchangeRate(purchaseRow);
          }
        },
      }
    );
  }

  _displayEuroAmount(purchaseRow, data) {
    const spinner = purchaseRow.querySelector(".currency-exchange-spinner");
    if (spinner) {
      spinner.remove();
    }
    const tooltipElement = purchaseRow.querySelector(".euro-amount");
    updateTooltipTitle(tooltipElement, numberToCurrency(data.euro_amount));
    tooltipElement.classList.remove("hidden");
  }

  _displayOngoingExchangeRate(purchaseRow) {
    const spinner = `
      <i 
        class='fa fa-spinner fa-pulse fa-lg fa-fw acasi_tooltip currency-exchange-spinner' style='color: rgba(0,0,0,0.6)' 
        data-toggle='tooltip' data-placement='left' title='Recherche du taux de change'>
      </i>
  `;

    purchaseRow.querySelector(".amount-column > div").insertAdjacentHTML("afterbegin", spinner);
  }

  _purchaseRow(purchaseId) {
    return document.querySelector(`.row-${purchaseId}`);
  }
}
